module.exports = __webpack_public_path__ + "static/media/private_game.21aca093.svg";